import React from 'react';

import lockSvg from 'four-nets/icons/svg/icon_lock.svg';
import userSvg from 'four-nets/icons/svg/icon_user.svg';
import usersSvg from 'four-nets/icons/svg/icon_users.svg';

import { PostVisibility } from 'four-nets/photoblog/create-post/mutations/create-post.graphql.types';
import { FormattedMessage } from 'react-intl';

export interface Props {
    value: PostVisibility;
    children: (options: React.ReactNode, beforeElement: string) => React.ReactNode;
}

class Options extends React.PureComponent<Props> {
    getSrc = (value: PostVisibility) => {
        switch (value) {
            case PostVisibility.POST_VISIBILITY_PUBLIC:
                return usersSvg;
            case PostVisibility.POST_VISIBILITY_AUTHENTICATED:
                return userSvg;
            case PostVisibility.POST_VISIBILITY_FRIENDS:
                return lockSvg;
            default:
                return lockSvg;
        }
    }

    render() {
        const { value } = this.props;

        const options = (
            <React.Fragment>
                <FormattedMessage id='PUBLIC_POST'>
                    {msg => (
                        <option
                            key={PostVisibility.POST_VISIBILITY_PUBLIC}
                            value={PostVisibility.POST_VISIBILITY_PUBLIC}
                        >
                            {msg}
                        </option>
                    )}
                </FormattedMessage>
                <FormattedMessage id='AUTHENTICATED_ONLY_POST'>
                    {msg => (
                        <option
                            key={PostVisibility.POST_VISIBILITY_AUTHENTICATED}
                            value={PostVisibility.POST_VISIBILITY_AUTHENTICATED}
                        >
                            {msg}
                        </option>
                    )}
                </FormattedMessage>
                <FormattedMessage id='FRIENDS_ONLY_POST'>
                    {msg => (
                        <option
                            key={PostVisibility.POST_VISIBILITY_FRIENDS}
                            value={PostVisibility.POST_VISIBILITY_FRIENDS}
                        >
                            {msg}
                        </option>
                    )}
                </FormattedMessage>
            </React.Fragment>
        );

        return this.props.children(options, this.getSrc(value));
    }
}

export default Options;
